export default __webpack_public_path__ + "static/media/bg-head-portfolio.256e9054.jpg";